import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import Reveal from "@/components/Reveal";
import { FAQS } from "@/constants/content";

export default function FAQ() {
  return (
    <section id="faq" className="relative bg-white py-20 sm:py-28" data-testid="faq-section">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="eyebrow text-center text-brandsky-deep">FAQ</p>
          <h2 className="font-display mx-auto mt-3 max-w-xl text-center text-3xl font-extrabold tracking-tight text-ink sm:text-4xl lg:text-[2.5rem] lg:leading-[1.06]">
            Questions offices ask us
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-10">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`item-${i}`} className="border-ink/10" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left text-[15.5px] font-bold text-ink hover:no-underline hover:text-brandsky-deep">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[14.5px] leading-relaxed text-slate-600">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}